import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import {
  WEBSEITE_NEU_FUER_ALLE,
  freigabeGemerkt,
  freigabeMerken,
  tabFreigabeGemerkt,
  vorschauAusAdresse,
  vorschauGemerkt,
  vorschauGewuenscht,
  vorschauMerken,
  webseiteNeuAktiv,
} from "@/lib/webseite/weiche";

/**
 * Weiche „Webseite neu“ (Regeln in `src/lib/webseite/weiche.ts`). Läuft im alten Kopf und Fuß, also auf fast jeder
 * öffentlichen Seite: Ohne Vorschauwunsch fragt der Hook nichts, weder die Anmeldung noch den Server. Mit Wunsch liest
 * er die Sitzung (lokal) und fragt einmal je Tab `ist_labs_tester()`. Bewusst ohne React Query, damit der alte Kopf
 * und Fuß auch ohne `QueryClientProvider` zeichnen wie bisher.
 */
export function useWebseiteNeu(fuerAlle: boolean = WEBSEITE_NEU_FUER_ALLE): boolean {
  const { search } = useLocation();
  const adresse = fuerAlle ? null : vorschauAusAdresse(search);
  const gewuenscht = !fuerAlle && vorschauGewuenscht({ adresse, gemerkt: vorschauGemerkt() });
  const [team, setTeam] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (adresse) vorschauMerken(adresse);
  }, [adresse]);

  useEffect(() => {
    if (!gewuenscht) return;
    let aus = false;
    void (async () => {
      const { data } = await supabase.auth.getSession();
      const userId = data.session?.user?.id ?? null;
      // Abgemeldet: nur, wenn der Server in diesem Tab schon „Team“ gesagt hat (weiche.ts, TAB_FREIGABE_SCHLUESSEL)
      if (!userId) {
        if (!aus) setTeam(tabFreigabeGemerkt());
        return;
      }
      const gemerkt = freigabeGemerkt(userId);
      if (gemerkt !== undefined) {
        if (!aus) setTeam(gemerkt);
        return;
      }
      const { data: istTeam, error } = await supabase.rpc("ist_labs_tester");
      const ja = !error && istTeam === true;
      if (!error) freigabeMerken(userId, ja);
      if (!aus) setTeam(ja);
    })();
    return () => {
      aus = true;
    };
  }, [gewuenscht]);

  return webseiteNeuAktiv({ fuerAlle, gewuenscht, team });
}
